// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__2X-rK","active":"PopoverSharedStyle_active__U3amu","backdrop":"PopoverSharedStyle_backdrop__ZWnxg"};